import { IUpdatePesquisaSatisfacaoClienteUseCase } from "../../../presentation/useCases/update/update_pesquisa_satisfacao_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdatePesquisaSatisfacaoClienteUseCase
 */

export class UpdatePesquisaSatisfacaoClienteUseCase implements IUpdatePesquisaSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updatePesquisaSatisfacaoCliente(
    idPesquisaSatisfacaoCliente: number,
    respondidaPor: string | null,
    data: Date | null,
    local: string | null,
    status: number,
    observacao: string | null,
    itens: { idItemPesquisaCliente: number, nota: number | null }[],
  ): Promise<void> {
    await this.repository.updatePesquisaSatisfacaoCliente(
      idPesquisaSatisfacaoCliente,
      respondidaPor,
      data,
      local,
      status,
      observacao,
      itens,
    );
  }
}
